module.exports = __webpack_public_path__ + "fonts/SFUIDisplay-Regular.b8d6156c.ttf";